import { render, staticRenderFns } from "./StudentsRemoveModal.vue?vue&type=template&id=46057bcf&"
import script from "./StudentsRemoveModal.vue?vue&type=script&lang=js&"
export * from "./StudentsRemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./StudentsRemoveModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports